export enum LabelHorizontalAlignmentMode {
  Center,
  Left,
  Right,
}
